import { BeckyThemeProvider, beckyTheme } from '@coolblue-development/themes';
import { useCallback, useEffect, useState } from 'react';
import CassieInjector from './components/CassieContainer/CassieInjector';
import { CassieWebsocketContextProvider } from './components/CassieContainer/websocket/CassieWebsocketContext';
import CatoContainer from './components/CatoContainer/CatoContainer';
import { CssBaseline } from '@mui/material';
import ErrorBoundary from './ErrorBoundary';
import ToolkitPanel from './components/ToolkitPanel/ToolkitPanel';
import { initializeDatadogRum } from './utils/initializeDatadogRum';
import { initializeDatadog } from './utils/initializeDatadog';

interface CatoConfProps {
  ccpInstanceURL: string;
  cppSamURL: string;
  title: string;
  region: string;
}

function App({ ccpInstanceURL, cppSamURL, title, region }: CatoConfProps): JSX.Element {
  const [contactId, setContactId] = useState<string | undefined>(undefined);

  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    initializeDatadog();
    initializeDatadogRum();
  }, []);

  const handleViewContact = useCallback((newContactId: string | undefined) => {
    if (!newContactId) {
      setContactId(undefined);
      return;
    }
    setContactId(newContactId);
  }, []);

  return (
    <>
      <BeckyThemeProvider theme={beckyTheme}>
        <ErrorBoundary>
          <CssBaseline />
          <CassieWebsocketContextProvider>
            <CatoContainer
              region={region}
              instanceURL={ccpInstanceURL}
              samURL={cppSamURL}
              onViewContact={handleViewContact}
            />
            <CassieInjector contactId={contactId} />
          </CassieWebsocketContextProvider>
          <ToolkitPanel />
        </ErrorBoundary>
      </BeckyThemeProvider>
    </>
  );
}

export default App;
